// Create a config module to store system configuration items
var gatorPadConfig = angular.module('gatorPadConfig', [])
  .config(['$httpProvider', '$locationProvider', function ($httpProvider, $locationProvider) {
  $httpProvider.defaults.useXDomain = true;
//  $httpProvider.defaults.headers.common["api-key"]='56619f99df5b5aca1faa2d4e';
  $httpProvider.defaults.headers.common["api-key"]='56744573cf2091a72b50e901';
}]);

gatorPadConfig.constant({
  baseApiUri: 'https://gatorapi-prod.clicrweight.com/api/v1/'
//  baseApiUri: 'http://localhost:8080/api/v1/'
});

var gatorPadApp = angular.module('GatorPad', [
  'ngRoute',
  'mobile-angular-ui',
  'gatorPadConfig',
  'underscore',
  'GatorPad.controllers.Main',
  'GatorPad.controllers.Login',
  'GatorPad.controllers.Logout',
  'GatorPad.controllers.Inventory',
  'GatorPad.controllers.Feed',
  'GatorPad.controllers.SavedData',
  'GatorPad.services.Api',
  'angularMoment'
]);

gatorPadApp.config(function ($routeProvider, $httpProvider) {
  $routeProvider.when('/', { redirectTo: '/inventoryTracker' });
  $routeProvider.when('/unsupportedBrowser', { templateUrl: 'unsupportedBrowser.html' });
  $routeProvider.when('/inventoryTracker', { templateUrl: 'inventory.html', controller: 'InventoryController', reloadOnSearch: false });
  $routeProvider.when('/feedEntry', { templateUrl: 'feed.html', controller: 'FeedController', reloadOnSearch: false });
  $routeProvider.when('/savedData', { templateUrl: 'savedData.html', controller: 'SavedDataController', reloadOnSearch: false });
  $routeProvider.when('/login', { templateUrl: 'login.html', controller: 'LoginController' });
  $routeProvider.when('/logout', { templateUrl: 'login.html', controller: 'LogoutController' });
});

gatorPadApp.run(function ($rootScope, $location) {
  $rootScope.$on("$routeChangeStart", function (event, next, current) {
    var sessionData = JSON.parse(window.localStorage.getItem("sessionData"));

    if (sessionData == null) {
      // no logged user, redirect to /login
      if (next.templateUrl === "templates/login.html") {
      } else {
        $location.path("/login");
      }
    } else {
      // user is logged in, initialize the current session
      $rootScope.sessionData = sessionData;
      if (navigator.onLine) {
        if (window.applicationCache) {
          window.applicationCache.update();
        }
      }
    }
  });

  window.applicationCache.addEventListener('updateready', function (e) {
    console.log("New application version was downloaded. Reloading.");
    window.location.reload();
  }, false);

});
    
// Add a date format helper
// Taken from http://stackoverflow.com/questions/3066586/get-string-in-yyyymmdd-format-from-js-date-object
Date.prototype.yyyymmdd = function () {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
  var dd = this.getDate().toString();
  return yyyy + (mm.length === 2 ? mm : "0" + mm[0]) + (dd.length === 2 ? dd : "0" + dd[0]); // padding
};
